import { Accordion, Button, Card, Col, Row, Table } from "react-bootstrap"
import moment from 'moment'

function HistoricExpC({data}){

    return(
        data.length > 0 ?
        <Row>
            <Col>
                <Accordion defaultActiveKey="0">
                    <Card>
                        <Card.Header className="p-0">
                            <Accordion.Toggle as={Button} variant="link" className="outline-none text-left" eventKey="0">
                                Antecedentes Heredo Familiares
                            </Accordion.Toggle>
                        </Card.Header>
                        <Accordion.Collapse eventKey="0">
                        <Card.Body>
                            {
                                data.map((item, i)=>(
                                    item.antecedentesFamiliares.length > 0 ? 
                                    <div key={i} className="border my-3">
                                        <label className="font-weight-bold px-2">{moment(item.appointment?.schedule?.hourInit, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YYYY HH:mm")}</label>
                                        <Table size="sm" className="m-0">
                                            <thead>
                                                <tr>
                                                    <th>Familiar</th>
                                                    <th>Diabetes</th>
                                                    <th>Hipertensión</th>
                                                    <th>Congénitos</th>
                                                    <th>Cardiológicos</th>
                                                    <th>Neurológicos</th>
                                                    <th>Vivo</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    item.antecedentesFamiliares.map((it, i)=>(
                                                        <tr key={i}>
                                                            <td>{it.tipoFamiliar?.nombreTipoFamiliar}</td>
                                                            <td>{it.diabetes}</td>
                                                            <td>{it.hipertension}</td>
                                                            <td>{it.congenitos}</td>
                                                            <td>{it.cardiologicos}</td>
                                                            <td>{it.neurologicos}</td>
                                                            <td>{it.vivo}</td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </Table>
                                    </div> :
                                    <div>
                                        <label className="font-weight-bold px-2 d-block m-0">{moment(item.appointment?.schedule?.hourInit, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YYYY HH:mm")}</label>
                                        <label className="px-2">No existe historial</label>
                                    </div>
                                ))
                            }
                        </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                    <Card>
                        <Card.Header className="p-0">
                            <Accordion.Toggle as={Button} variant="link" eventKey="1">Antecedentes no patológicos</Accordion.Toggle>
                        </Card.Header>
                        <Accordion.Collapse eventKey="1">
                            <Card.Body>
                            {
                                data.map((item, i)=>(
                                    <div key={i} className="border my-3">
                                        <label className="font-weight-bold px-2">{moment(item.appointment?.schedule?.hourInit, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YYYY HH:mm")}</label>
                                        <Table size="sm" className="m-0">
                                            <thead>
                                                <tr>
                                                    <th>Vive con</th>
                                                    <th>Mascotas</th>
                                                    <th>Cuenta con servicios básicos</th>
                                                    <th>Tipo piso</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>{item.antecedentesNoPatologicos?.viveCon?.nombreFamiliar}</td>
                                                    <td>{item.antecedentesNoPatologicos?.mascotas?.nombreMascota}</td>
                                                    <td>{
                                                            item.antecedentesNoPatologicos?.servicios === 'AguaLuzGas' ? 'Agua, Luz, Gas' :
                                                            item.antecedentesNoPatologicos?.servicios
                                                        }
                                                    </td>
                                                    <td>{item.antecedentesNoPatologicos?.tipoPiso}</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </div>
                                ))
                            }
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                    <Card>
                        <Card.Header className="p-0">
                            <Accordion.Toggle as={Button} variant="link" eventKey="2">Antecedentes patológicos</Accordion.Toggle>
                        </Card.Header>
                        <Accordion.Collapse eventKey="2">
                            <Card.Body>
                            {
                                data.map((item, i)=>(
                                    item.antecedentesPatologicos.length > 0 ? 
                                    <div key={i} className="border my-3">
                                        <label className="font-weight-bold px-2">{moment(item.appointment?.schedule?.hourInit, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YYYY HH:mm")}</label>
                                        <Table size="sm" className="m-0">
                                            <thead>
                                                <tr>
                                                    <th>Enfermedad</th>
                                                    <th>Pres. padecimiento</th>
                                                    <th>Años</th>
                                                    <th>Meses</th>
                                                    <th>Tratamiento</th>
                                                    <th>Observaciones</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    item.antecedentesPatologicos.map((it, i)=>(
                                                        <tr key={i}>
                                                            <td width="20%">{it.enfermedad?.nombreEnfermedad}</td>
                                                            <td width="14%">{it.presentaPadecimiento}</td>
                                                            <td width="8%">{it.anios}</td>
                                                            <td width="8%">{it.meses}</td>
                                                            <td width="20%">{it.tratamiento}</td>
                                                            <td width="30%">{it.observaciones}</td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </Table>
                                    </div> :
                                    <div>
                                        <label className="font-weight-bold px-2 d-block m-0">{moment(item.appointment?.schedule?.hourInit, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YYYY HH:mm")}</label>
                                        <label className="px-2">No existe historial</label>
                                    </div>
                                ))
                            }
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                    </Accordion>
            </Col>
        </Row>
        :
        <Row>
            <Col>No existe historial</Col>
        </Row>
    )

}

export default HistoricExpC